export const REGISTER_ALREADY_REGISTERED = 'User_Has_Been_Already_Registered'
export const REGISTER_FAILURE_PREFIX = 'Failed_To_Register_User_Account_'

const REGISTER_FAILURE_DETAIL_PATTERN = /^Failed_To_Register_User_Account_\((.+)\)$/

export function extractRegisterFailureDetail(raw) {
  if (typeof raw !== 'string' || !raw.startsWith(REGISTER_FAILURE_PREFIX)) {
    return null
  }

  const match = raw.match(REGISTER_FAILURE_DETAIL_PATTERN)

  if (match) {
    return match[1]
  }

  const suffix = raw.slice(REGISTER_FAILURE_PREFIX.length)

  return suffix || null
}

export function parseWebRegisterResponse(response) {
  if (typeof response === 'string') {
    return {
      raw: response,
      isFailure: response.includes(REGISTER_FAILURE_PREFIX),
      isAlreadyRegistered:
        response === REGISTER_ALREADY_REGISTERED || response.includes(REGISTER_ALREADY_REGISTERED),
      failureDetail: extractRegisterFailureDetail(response),
      codeSent: false,
      authToken: null,
    }
  }

  return {
    raw: response,
    isFailure: false,
    isAlreadyRegistered: false,
    failureDetail: null,
    codeSent: Boolean(response?.codeSent),
    authToken: response?.auth_token ?? null,
  }
}
